{
  "es": {
    "nav": {
      "locations": "Ubicaciones",
      "home": "Inicio",
      "back": "Atrás",
      "navigation": "Navegación",
      "ships": {
        "index": "Naves"
      },
      "compare": {
        "index": "Comparar",
        "ships": "Comparar Naves"
      },
      "manufacturers": "Fabricantes",
      "images": "Imágenes",
      "videos": "Vídeos",
      "shipHistory": "Historial",
      "componentHistory": "Historial",
      "hangar": {
        "index": "Mi Hangar",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventories",
        "vehicleCargo": "Carga",
        "buybacks": "Recompras",
        "imports": "Importaciones",
        "transfers": "Transferencias"
      },
      "login": "Iniciar sesión",
      "installApp": "Instalar app",
      "logout": "Cerrar sesión",
      "apiV1": "API v1",
      "apiV1Schema": "Esquema",
      "apiV1Pagination": "Paginación",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Esquema",
      "embed": "Widget Incrustado",
      "signUp": "Registrarse",
      "privacyPolicy": "Política de privacidad",
      "impressum": "Aviso legal",
      "fleets": {
        "index": "Flotas",
        "add": "Crear una nueva flota",
        "invites": "Invitaciones",
        "ships": "Naves",
        "blueprints": "Planos",
        "assets": "Activos",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "Mapa mundial",
          "starmap": "Mapa estelar"
        },
        "squadrons": {
          "index": "Escuadrones",
          "overview": "Resumen",
          "members": "Miembros",
          "create": {
            "details": "Detalles",
            "appearance": "Apariencia",
            "discord": "Discord"
          },
          "edit": {
            "details": "Detalles",
            "appearance": "Apariencia",
            "discord": "Discord"
          }
        },
        "stats": "Estadísticas",
        "logistics": {
          "index": "Logistics"
        },
        "missions": {
          "index": "Misiones",
          "edit": {
            "details": "Detalles",
            "teams": "Equipos y plazas"
          }
        },
        "events": {
          "index": "Eventos",
          "calendar": "Calendario",
          "edit": {
            "details": "Detalles",
            "schedule": "Programación",
            "signup": "Inscripción",
            "teams": "Equipos y plazas"
          },
          "payouts": "Pagos"
        },
        "tours": "Expediciones",
        "settings": {
          "index": "Configuración",
          "fleet": "Configuración de flota",
          "rsi": "ID de flota y RSI",
          "membership": "Configuración de membresía",
          "roles": "Roles",
          "squadrons": "Escuadrones",
          "allies": "Aliados",
          "notifications": "Notificaciones",
          "discord": "Discord",
          "calendar": "Calendario",
          "features": "Funciones",
          "contracts": "Contratos"
        },
        "contracts": {
          "index": "Contratos",
          "payouts": "Pagos"
        },
        "directory": "Directorio"
      },
      "rsiProfile": "Perfil RSI",
      "rsiHangar": "Hangar RSI",
      "tools": {
        "index": "Herramientas",
        "travelTimes": "Tiempos de Viaje",
        "cargoGrids": "Grillas de Carga",
        "tradeRoutes": "Rutas comerciales",
        "tours": "Expediciones"
      },
      "api": "Documentación API",
      "stats": "Estadísticas",
      "toggleSlimCollapse": "Contraer",
      "toggleSlimExpand": "Expandir",
      "roadmap": {
        "index": "Hoja de ruta",
        "overview": "Visión general",
        "changes": "Cambios",
        "ships": "Roadmap de naves"
      },
      "rsiVerification": "Verificación RSI",
      "settings": {
        "index": "Configuración",
        "profile": "Perfil",
        "account": "Cuenta",
        "security": "Seguridad",
        "notifications": "Notificaciones",
        "calendar": "Calendario",
        "donations": "Donaciones",
        "hangar": "Hangar",
        "privacy": "Privacidad",
        "features": "Funciones",
        "connections": "Conexiones",
        "oauthApplications": "Apps OAuth",
        "verify": "Verificación de cuenta RSI",
        "friends": "Amigos"
      },
      "reload": "¡Actualización disponible!",
      "visualTests": {
        "blueprints": "Planos",
        "index": "Pruebas Visuales",
        "panels": "Paneles",
        "buttons": "Botones",
        "events": "Eventos",
        "typography": "Tipografía",
        "forms": "Formularios",
        "tables": "Tablas",
        "lists": "Listas",
        "metrics": "Métricas",
        "states": "Estados",
        "notifications": "Notificaciones",
        "syncModal": "Modal de sincronización",
        "overlays": "Superposiciones",
        "installPrompt": "Aviso de instalación",
        "supportHint": "Aviso de apoyo",
        "media": "Multimedia",
        "charts": "Gráficos",
        "alerts": "Avisos",
        "verifiedBadges": "Insignias de verificación",
        "chips": "Chips",
        "squadrons": "Escuadrones",
        "groups": {
          "foundations": "Fundamentos",
          "data": "Datos",
          "feedback": "Feedback",
          "features": "Funciones"
        },
        "notificationCenter": "Centro de notificaciones",
        "themes": "Temas"
      },
      "admin": {
        "features": {
          "overview": "Resumen",
          "users": "Usuarios",
          "fleets": "Flotas",
          "history": "Historial"
        },
        "locations": {
          "index": "Ubicaciones"
        },
        "blueprints": {
          "index": "Planos"
        },
        "missions": {
          "index": "Misiones"
        },
        "index": "Admin",
        "models": {
          "index": "Modelos",
          "create": "Crear Modelo",
          "edit": {
            "index": "Datos Base",
            "metrics": "Métricas",
            "prices": "Precios",
            "docks": "Muelles",
            "modules": "Módulos",
            "paints": "Pinturas",
            "images": "Imágenes",
            "videos": "Videos",
            "cargoAndFuel": "Carga y Combustible",
            "cargoHolds": "Bodegas de carga",
            "fleetchart": "Imágenes Fleetchart",
            "positions": "Posiciones",
            "hardpoints": "Puntos de montaje",
            "loaners": "Prestados",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Mejoras",
            "packages": "Paquetes",
            "history": "Historial"
          }
        },
        "modelPaints": {
          "index": "Pinturas",
          "create": "Crear Pintura"
        },
        "modelModules": {
          "index": "Módulos",
          "create": "Crear Módulo",
          "edit": {
            "index": "Datos Base",
            "models": "Modelos",
            "prices": "Precios",
            "hardpoints": "Puntos de Conexión",
            "docks": "Muelles",
            "cargoHolds": "Bodegas de carga",
            "history": "Historial"
          }
        },
        "unlistedModels": {
          "index": "Naves no listadas"
        },
        "modelModulePackages": {
          "index": "Paquetes de Módulos",
          "create": "Crear Paquete de Módulos"
        },
        "components": {
          "index": "Componentes",
          "edit": {
            "index": "Datos base",
            "prices": "Precios",
            "history": "Historial"
          }
        },
        "manufacturers": {
          "index": "Fabricantes",
          "edit": {
            "index": "Datos básicos",
            "models": "Naves",
            "components": "Componentes",
            "equipment": "Equipamiento",
            "modules": "Módulos"
          }
        },
        "images": {
          "index": "Imágenes"
        },
        "users": {
          "index": "Usuarios",
          "edit": "Editar",
          "fleets": "Flotas",
          "inventories": "Inventarios",
          "supporterContributions": "Aportaciones"
        },
        "fleets": {
          "index": "Flotas",
          "edit": "Editar",
          "members": "Miembros",
          "history": "Historial",
          "roles": "Roles",
          "inventories": "Inventarios"
        },
        "fleetFidClaims": {
          "index": "Reclamaciones de FID"
        },
        "destroyedFleets": {
          "index": "Flotas eliminadas"
        },
        "vehicles": {
          "index": "Vehículos"
        },
        "admins": {
          "index": "Administradores"
        },
        "oauthApplications": {
          "index": "Apps OAuth"
        },
        "maintenance": {
          "index": "Mantenimiento",
          "pghero": "PG-Hero",
          "features": "Características",
          "workers": "Trabajadores",
          "tasks": "Tareas",
          "imports": "Importaciones",
          "rsiApiStatus": "Estado API RSI",
          "buildCompare": "Comparar compilaciones"
        },
        "announcements": {
          "index": "Anuncios",
          "new": "Nuevo anuncio",
          "edit": "Editar anuncio"
        },
        "supporterContributions": {
          "index": "Contribuciones de patrocinadores",
          "new": "Nueva contribución",
          "edit": "Editar contribución"
        },
        "fundingGoals": {
          "index": "Objetivos de financiación",
          "new": "Nuevo objetivo de financiación",
          "edit": "Editar objetivo de financiación"
        },
        "notifications": {
          "index": "Notificaciones"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "Pruebas Visuales",
          "notifications": "Notificaciones"
        },
        "groups": {
          "catalogue": "Catálogo",
          "community": "Comunidad",
          "people": "Personas",
          "system": "Sistema"
        }
      },
      "notifications": "Notificaciones",
      "scDataSource": "Fuente de datos",
      "commodities": {
        "index": "Mercancías"
      },
      "components": {
        "index": "Componentes"
      },
      "catalogue": {
        "commodities": "Mercancías",
        "index": "Catálogo",
        "components": "Componentes",
        "blueprints": "Planos",
        "missions": "Misiones",
        "equipment": "Equipo"
      },
      "equipment": {
        "index": "Equipo"
      }
    }
  }
}
